import { createRouter, createWebHistory } from "vue-router";
import { getStorage } from "@/utils";
import routes from "./routes";
import { routeWhites } from "./routerConfig";

const router = createRouter({
    history: createWebHistory(),
    routes: [...routes],
    scrollBehavior(to, from, savedPosition) {
        if (to.path === from.path) return;
        if (savedPosition) {
            return { ...savedPosition, behavior: "instant" };
        } else {
            if (from.meta.saveSrollTop) {
                from.meta.savedPosition = document.documentElement.scrollTo || document.body.scrollTop;
            }
            return { left: 0, top: to.meta.savedPosition || 0, behavior: "instant" };
        }
    },
});

/* 路由拦截器 */
router.beforeEach(async (to, from, next) => {
    if (to.meta.title) document.title = to.meta.title;
    // 判断除登录页等白名单页面，其他页面的query如果存在分享和预览token就带到下一个页面
    const share = from.query.share || to.query.share || "";
    const previewToken = from.query.previewToken || to.query.previewToken || "";
    const preview = from.query.preview || to.query.preview || "";
    const q = {};
    if (!routeWhites.includes(to.path)) {
        if (share) q.share = share;
        if (previewToken) q.previewToken = previewToken;
        if (preview) q.preview = preview;
    }
    to.query = { ...to.query, ...q };
    // 登录判断
    const token = getStorage("token") || false;
    if (share || previewToken) {
        next();
    } else if (token) {
        // 已登录
        // 在免登录白名单，进入首页
        if (routeWhites.includes(to.path)) {
            next("/");
        } else {
            next();
        }
    } else {
        // 未登录
        // 在免登录白名单，直接进入
        if (routeWhites.includes(to.path)) {
            next();
        } else {
            next("/login");
        }
    }
});

export default router;
